import React, { Component } from "react";
import MainContainer from "./components/MainContainer";
import "antd/dist/antd.css";
import "./assets/sass/responsive.scss";

import { addLocaleData } from "react-intl";
import ptLocaleData from "react-intl/locale-data/pt";
import enLocaleData from "react-intl/locale-data/en";
import esLocaleData from "react-intl/locale-data/es";

addLocaleData([...ptLocaleData, ...enLocaleData, ...esLocaleData]);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="App">
        <MainContainer />
      </div>
    );
  }
}

export default App;
